var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"pa-3",attrs:{"rounded":""}},[_c('h2',{staticClass:"text-h5 mb-4"},[_vm._v(_vm._s(_vm.$t(_vm.resultData.title)))]),(_vm.resultData.alert)?_c('v-alert',{class:_vm.resultData.alert.type === 'error'
        ? 'message-wrapper error-message'
        : null,attrs:{"outlined":_vm.resultData.alert.type === 'warning',"color":"primary","icon":_vm.resultData.alert.icon}},[_c('span',{staticClass:"black--text"},[_vm._v(" "+_vm._s(_vm.$t(_vm.resultData.alert.message))+" ")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }